/** @format */

export { RenderWidget as StudyWidget } from "@/components.studies/study-widget-grid/ts/RenderWidget";
